define('core/modules/togglr',["jquery", "core/modules/breakdance", "core/ef_plugins/togglr", "core/ef_plugins/expando", "core/ef_plugins/truncatr"], function($, breakdance) {
    console.log('togglr');

    return {
        init: function () {
            var $expando = $('.js-expando, .js-expando-mobile');

            // Toggle
            $('.toggle-label').togglr();

            // Expando
            $expando.truncatr();
            $expando.find('.js-expando-trigger').togglr();
            $expando.find('.truncatr-full')
                .expando({ excerpt: '.truncatr-excerpt' })
                .each(function () {
                    var $this = $(this),
                        expando = $this.data('plugin_expando'),
                        $fullP = expando.$element.find('p:last'),
                        $excerptP = expando.$excerpt.find('p:last'),
                        $trigger = expando.$trigger;
                    // Put the trigger in the active content.
                    $this.on('expando-expand', function () { $fullP.append($trigger); });
                    $this.on('expando-collapse', function () { $excerptP.append($trigger); });
                    $fullP.add($excerptP).append(' ');
                    // Put the trigger in the excerpt on init. If there is no excerpt
                    // (becuase the content is too short), this line will remove the trigger.
                    $excerptP.append($trigger);
            });
            
            // Drawer
            $('.js-drawer-trigger').togglr({ toggleText: false });
            $('.js-drawer').expando({ trigger: '.js-drawer-trigger' });

            // Mobile Drawer
            // Where possible, it's simplest to handle the mobile/desktop switch
            // in CSS: hide the trigger; show the expando. In the drawer on the
            // review page, we're showing the trigger on desktop, so we need to
            // actually destroy and re-create the plugin when we switch breakpoints.

            function createMobileDrawer() {
                $('.js-drawer-trigger-mobile').togglr({ toggleText: false });
                $('.js-drawer-mobile').expando({ trigger: '.js-drawer-trigger-mobile' });
            }
            function destroyMobileDrawer() {
                var togglr = $('.js-drawer-trigger-mobile').data('plugin_togglr'),
                    expando = $('.js-drawer-mobile').data('plugin_expando');
                if (togglr) { togglr.destroy(); }
                if (expando) { expando.destroy(); }
            }
            breakdance.register(749, createMobileDrawer, destroyMobileDrawer);
        }
    };
});
